"use client";import{useState as t}from"react";const e=(e=!1)=>{const[r,o]=t(e);return[r,()=>{o((t=>!t))}]};export{e as default};
